import React from 'react';
import { Card, CardContent } from '../ui/card';
import { ShieldCheck, FileText, Users, CreditCard, DollarSign, Shield } from 'lucide-react';

const AboutSection = () => {
  const services = [
    {
      icon: ShieldCheck,
      title: "Gold Testing & Verification",
      description: "Professional assay and quality certification"
    },
    {
      icon: FileText,
      title: "Legal Compliance",
      description: "All export fees, taxes, and documentation"
    },
    {
      icon: Users,
      title: "Direct Buyer",
      description: "A single trusted contact from export to final delivery"
    },
    {
      icon: DollarSign,
      title: "Tax Payment",
      description: "We cover all local fees up to the final destination"
    }
  ];

  return (
    <section id="about" className="py-24 bg-[#020817]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#D4AF37]/20 rounded-3xl"></div>
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-[#040F2D]/10 rounded-3xl"></div>
            <img
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1400&q=80&auto=format&fit=crop"
              alt="Trusted partnership and handshake — GOLDCIF buyer commitment"
              className="relative z-10 w-full h-[420px] object-cover rounded-3xl shadow-2xl"
            />
          </div>
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">We Are The Final Buyer</h2>
            <p className="text-xl text-white/80 leading-relaxed mb-6">
              GOLDCIF provides a complete legal pathway for African artisanal miners to access international gold market with full transparency.
            </p>
            <p className="text-base text-white/70 leading-relaxed mb-6">
              No middlemen, no broker chain. We meet you on the ground, test your gold, handle every export formality, and pay you directly — turning hand-mined gold into legitimate, traceable global commerce.
            </p>
            <p className="text-base text-white/70 leading-relaxed">
              We operate on <strong className="text-white">CIF terms</strong> and we also buy on-site — but only after verifying the origin of the gold and confirming it is not sourced from any conflict zone, in full compliance with OECD due-diligence standards. <strong className="text-white">All purchases take place exclusively in licensed, legal locations</strong> — never in hotels, private residences or Airbnb.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card key={index} className="group hover:shadow-2xl transition-all duration-500 border-0 bg-[#0B132B]/60 hover:scale-105 transform">
                <CardContent className="p-8 text-center">
                  <div className="w-20 h-20 bg-gradient-to-br from-[#D4AF37] to-[#C5A059] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:rotate-6 transition-transform duration-300">
                    <IconComponent className="h-10 w-10 text-white" />
                  </div>
                  <h3 className="font-bold text-white mb-4 text-xl group-hover:text-[#0B132B] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-white/70">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-20 text-center">
          <div className="bg-gradient-to-r from-[#040F2D] to-[#0B132B] rounded-3xl p-12 text-white">
            <div className="flex items-center justify-center mb-6">
              <Shield className="h-12 w-12 text-[#D4AF37] mr-4" />
              <h3 className="text-4xl font-bold text-[#D4AF37]">Compliance-First Approach</h3>
            </div>
            <p className="text-xl max-w-4xl mx-auto opacity-90">
              Every single transaction is fully documented, legally compliant, and transparently executed from start to finish.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;